export const pbjPath = {
  PBJ_EXPORT: '/pbj',
};

/**
 * RA-2027 tunables, deliberately together in one place.
 *
 * The reports-automation service now logs `dataset / render / gates / archive / total` on every
 * request, so these are expected to be retuned once real per-stage timings land. Keeping them in
 * one file means that is a one-file change rather than a hunt through the card.
 */

/**
 * The shared Axios interceptor sets no timeout, so this request would otherwise wait forever and a
 * genuine hang would teach the user nothing. Generous on purpose: generation is synchronous and
 * measured at ~11s for 100 facilities *excluding* DB time, which is unmeasured because no
 * environment we have holds a tenant that size.
 *
 * Scoped to this one call. A global timeout on the interceptor would change behaviour for every
 * other request in the app.
 */
export const PBJ_REQUEST_TIMEOUT_MS = 120000;

/**
 * The span the progress animation eases over — roughly the measured worst case, not the timeout.
 * Overshooting it is harmless because the animation asymptotes rather than finishing.
 */
export const PBJ_PROGRESS_EXPECTED_MS = 15000;

/**
 * The animation's hard ceiling. It must stay below 100: a bar that completes while the request is
 * still in flight tells the user the work is done or hung, and they start the retry loop. Easing to
 * an asymptote can look slow but it cannot lie in that direction.
 */
export const PBJ_PROGRESS_CEILING_PERCENT = 90;

/** Animation frame interval. Coarse on purpose — this is a reassurance, not a measurement. */
export const PBJ_PROGRESS_TICK_MS = 200;

/** How long 100% stays on screen after the file lands, so the snap is actually seen. */
export const PBJ_PROGRESS_COMPLETE_HOLD_MS = 700;

/** The 404 code the service returns when the quarter simply has no labor in it. */
export const PBJ_NO_DATA_CODE = 'PBJ_NO_DATA_FOR_QUARTER';
